import * as React from 'react';
import PhoneInput from 'react-phone-number-input';
import en from 'react-phone-number-input/locale/en.json';
import 'react-phone-number-input/style.css';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { StateType } from '../../reducers';

import { FieldPropsDispatchers, FieldStateProps, InputConnectProps, InputTelefopne } from './types';
import { FieldSet } from './FieldSet';

en.CN = 'Mainland China';
const TELEPHONE_NAME = 'telephone';

const InputConnectTelephone = ({
  label,
  id,
  modifiers = [],
  disabled = false,
  value,
  placeholder = '',
  required = false,
  dispatchChangeField,
  errors,
  tabIndex,
  dispatchOnBlurField,
}: InputTelefopne) => (
  <FieldSet id={id} label={label} required={required} modifiers={modifiers} errors={errors}>
    <PhoneInput
      id={id}
      name={id}
      value={value}
      placeholder={placeholder}
      className="form__input input-connect-telephone"
      disabled={disabled}
      onChange={dispatchChangeField}
      onBlur={dispatchOnBlurField}
      labels={en}
      tabIndex={tabIndex}
    />
  </FieldSet>
);

const mapStateToProps = (state: StateType, ownProps: InputConnectProps): FieldStateProps => ({
  value: state.getIn(ownProps.pathValue),
  errors: state.getIn(ownProps.pathErrors),
});

const mapDispatchToProps = (dispatch: Dispatch<any>, ownProps: InputConnectProps): FieldPropsDispatchers => {
  // Helper function to adapt React PhoneNumber component to the expected callback format
  const callbackWrapper = (changedValue: any) => {
    dispatch(
      ownProps.onChangeFieldAction({
        value: changedValue,
        name: TELEPHONE_NAME,
        id: TELEPHONE_NAME,
      })
    );
  };

  return {
    dispatchChangeField: callbackWrapper,
    dispatchOnBlurField: (event: any) => {
      event.persist();
      dispatch(ownProps.onChangeFieldAction({ ...event, name: TELEPHONE_NAME }));
    },
  };
};

export default connect<FieldStateProps, (dispatch: Dispatch<any>, ownProps: InputConnectProps) => FieldPropsDispatchers, any, StateType>(
  mapStateToProps,
  mapDispatchToProps
)(InputConnectTelephone);
